<template>
  <div class="no_Data">
    <div class="no_top">
      <p class="border_p">
        <span>今日学习任务</span>
        <strong @click="openWeek_box1" v-if="open"
          >点击收起<i class="el-icon-caret-top"></i
        ></strong>
        <strong @click="openWeek_box2" v-else
          >点击收起<i class="el-icon-caret-bottom"></i
        ></strong>
      </p>
      <div class="week_box" v-show="open1">
        <div class="week_box_top">
          <div class="all_em_left" @click="pick">今天</div>
          <div class="LR_btn">
            <img
              src="../../assets/personal/icon_Left.png"
              alt=""
              @click="weekPre"
            />
            <div class="time_box">
              {{ currentYear }} 年 {{ currentMonth }} 月
            </div>
            <img
              src="../../assets/personal/icon_right.png"
              alt=""
              @click="weekNext"
            />
          </div>
          <div class="all_em_right" @click="openMonth_box1">
            按月展示
            <img src="../../assets/personal/icon_more.png" alt="" />
          </div>
        </div>
        <div class="date_count">
          <el-scrollbar style="height: 100%">
            <ul>
              <li v-for="(item, index) in daysListNew" :key="index">
                <div class="date_count_top">
                  <span :class="{ active: item.taDay }">
                    <strong>{{ item.day.getDate() }}</strong>
                    {{ weekList[item.day.getDay()] }}
                  </span>
                </div>
                <div class="date_count_bottom">
                  <div class="item" v-for="(item2, index2) in item.alist">
                    <div class="itemTop">
                      <span
                        >{{ item2.BeginTime.slice(11, 16) }}-{{
                          item2.EndTime.slice(11, 16)
                        }}</span
                      >
                      <span v-if="item2.ContentType == 48"
                        >第{{ item2.Lable }}节</span
                      >
                      <span v-if="item2.ContentType == 183">公开课</span>
                      <span v-if="item2.ContentType == 184">语言测试</span>
                    </div>
                    <div class="itemBottom">
                      <strong>{{ item2.Title }}</strong>
                      <div
                        class="itemButton"
                        v-if="item2.ClassType == 31"
                        @click="
                          studio(
                            item2.RoomId,
                            item2.ContentType,
                            item2.Id,
                            item2.timestampsB,
                            item2.timestampsE,
                            item2.CourseId
                          )
                        "
                      >
                        查看视频
                      </div>
                      <div
                        class="itemButton"
                        v-else
                        @click="
                          studio(
                            item2.RoomId,
                            item2.ContentType,
                            item2.Id,
                            item2.timestampsB,
                            item2.timestampsE,
                            item2.CourseId
                          )
                        "
                        :class="{
                          cursor:
                            item2.timestampsB < curTime &&
                            DateTime < item2.timestampsE
                        }"
                      >
                        {{
                          item2.timestampsE > DateTime
                            ? "进入直播间"
                            : "查看回放"
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </el-scrollbar>
        </div>
      </div>
      <div class="month_box" v-show="open2">
        <div class="all_em_right" @click="openMonth_box3">
          按周展示
          <img src="../../assets/personal/icon_more.png" alt="" />
        </div>
        <xxcalendar ref="xxcalendar" />
      </div>
    </div>
  </div>
</template>
<script>
import xxcalendar from "../xxcalendar/xxcalendar.vue";
export default {
  components: {
    xxcalendar
  },
  name: "NoData",
  data() {
    return {
      open: true,
      open1: true,
      open2: false,
      weekList: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      DateTime: "", //系统时间
      currentYear: "", // 年份
      currentMonth: "", // 月份
      currentDay: "", // 日期
      currentWeek: "", // 星期
      daysList: [],
      daysListNew: [],
      showYZ: 1,
	  curTime:0,
    };
  },
  created() {
    this.tokenkey = this.$cookies.get("token");
    // this.getInto();
    //获取系统时间
    this.ServerDateTime();
    // 下面的日历
    this.initData();
  },
  methods: {
    // 初始加载第一天
    // getInto() {
    // this.TaskCenterS1(
    //   this.year + "-" + this.month + "-" + this.curryDate,
    //   this.years + "-" + this.months + "-" + this.days
    // );
    // },
    // 系统时间
    ServerDateTime() {
      let that = this;
      this.$http
        .get("https://schoolapi.eiceducation.com.cn/api/ServerDateTime")
        .then(function(result) {
          let resultsT = new Date(
            result.data.results.replace("-", "/").replace("-", "/")
          );
          that.DateTime = parseInt(resultsT.getTime());
          that.curTime = parseInt(resultsT.getTime())+10*60*1000;
          // console.log(process.env.NODE_ENV, "console.log(process.env.NODE_ENV)")
        })
        .catch(function(error) {
          // console.log(error);
          that.$message.error(error);
        });
    },
    openWeek_box1() {
      this.open = false;
      this.open1 = false;
      this.open2 = false;
    },
    openWeek_box2() {
      this.open = true;
      if (this.showYZ == 1) {
        this.open1 = true;
        this.open2 = false;
      } else {
        this.open1 = false;
        this.open2 = true;
      }
    },
    openMonth_box1() {
      this.open1 = false;
      this.open2 = true;
      this.showYZ = 2;
    },
    openMonth_box3() {
      this.open1 = true;
      this.open2 = false;
      this.showYZ = 1;
    },
    // TaskCenterS1(todayF, todayL) {
    //   let that = this;
    //   this.$http
    //     .get(
    //       "https://schoolapi.eiceducation.com.cn/api/TaskCenter?beginTime=" +
    //       todayF +
    //       "&endTime=" +
    //       todayL, {
    //         headers: {
    //           token: that.tokenkey
    //         }
    //       }
    //     )
    //     .then(function(result) {
    //       // // console.log(result)
    //       if (result.data.count > 0) {
    //         that.TaskCenterL = result.data.results;
    //         let timeLB = [];
    //         let ksTime = [];
    //         let jsTime = [];
    //         for (let i in result.data.results) {
    //           if (result.data.results[i].BeginTime != null) {
    //             result.data.results[i].BeginTime = result.data.results[
    //               i
    //             ].BeginTime.replace("-", "/").replace("-", "/");
    //           }
    //           if (result.data.results[i].EndTime != null) {
    //             result.data.results[i].EndTime = result.data.results[
    //               i
    //             ].EndTime.replace("-", "/").replace("-", "/");
    //           }
    //           timeLB.push(
    //             result.data.results[i].BeginTime.slice(11, 16) +
    //             "-" +
    //             result.data.results[i].EndTime.slice(11, 16)
    //           );
    //           ksTime.push(
    //             new Date(result.data.results[i].BeginTime).getTime() / 1000
    //           );
    //           jsTime.push(
    //             new Date(result.data.results[i].EndTime).getTime() / 1000
    //           );
    //         }
    //         // that.timeLB = timeLB;
    //         // that.ksTime = ksTime;
    //         // that.jsTime = jsTime;
    //         // console.log(that.ksTime)
    //         // console.log(that.jsTime)
    //       } else {}
    //     })
    //     .catch(function(error) {
    //       // console.log(error);
    //       that.$message.error(error);
    //     });
    // },
    // 进入直播间
    studio(roomid, contentType, contentId, timestampsB, timestampsE, CourseId,) {
      this.ServerDateTime();
      if (timestampsB > this.curTime) return;
      if (this.DateTime > timestampsE) {
        window.open(
          "https://online.eickaopei.com/course_details?Id=" +
            CourseId +
            "&nav=8&active=1"
        );
        return;
      }
      console.log(timestampsB, timestampsE, this.DateTime);
      let that = this;
      this.$http
        .get(
          "https://schoolapi.eiceducation.com.cn/api/BJYSign?contentType=" +
            contentType +
            "&contentId=" +
            contentId +
            "&roomid=" +
            roomid,
          {
            headers: {
              token: that.tokenkey
            }
          }
        )
        .then(function(result) {
          // // console.log(result)
          let room_id = roomid; //房间号
          let user_number = that.$parent.Number; //用户数字ID
          let user_role = 0; //用户身份0:学生 1:老师 2:管理员
          let user_name = that.$parent.NickName; //用户名
          let user_avatar = that.$parent.HeadUrl; //用户头像
          let sign = result.data.results; //用户签名
          let web_url =
            "https://b96135432.at.baijiayun.com/web/room/enter?room_id=" +
            roomid +
            "&user_number=" +
            user_number +
            "&user_role=" +
            user_role +
            "&user_name=" +
            user_name +
            "&user_avatar=" +
            user_avatar +
            "&sign=" +
            sign;
          window.open(web_url);
        })
        .catch(function(error) {
          // console.log(error);
          that.$message.error(error);
        });
    },

    cutNavMenu(path, index, leftnav) {
      // // console.log(path, index, leftnav)
      // // console.log(this.$parent)
      this.$parent.index = index;
      this.$parent.activeName = leftnav;
      // sessionStorage.setItem("activeIndex", index);
      this.$router.push({
        path: `/personalCentre/${path}`
      });
    },
    // 下面的日历
    formatDate(year, month, day) {
      const y = year;
      let m = month;
      if (m < 10) m = `0${m}`;
      let d = day;
      if (d < 10) d = `0${d}`;
      return `${y}-${m}-${d}`;
    },

    initData(cur) {
      this.daysListNew = [];
      let date = "";
      if (cur) {
        date = new Date(cur);
      } else {
        date = new Date();
      }
      let _date2 =
        new Date().getFullYear() +
        "-" +
        new Date().getMonth() +
        "-" +
        new Date().getDate();
      this.currentDay = date.getDate(); // 今日日期 几号
      this.currentYear = date.getFullYear(); // 当前年份
      this.currentMonth = date.getMonth() + 1; // 当前月份
      this.currentWeek = date.getDay(); // 1...6,0   // 星期几
      if (this.currentWeek === 0) {
        this.currentWeek = 7;
      }
      const str = this.formatDate(
        this.currentYear,
        this.currentMonth,
        this.currentDay
      ); // 今日日期 年-月-日
      this.daysList.length = 0;
      // 今天是周日，放在第一行第7个位置，前面6个 这里默认显示一周，如果需要显示一个月，则第二个循环为 i<= 35- this.currentWeek
      /* eslint-disabled */
      for (let i = this.currentWeek - 1; i >= 0; i -= 1) {
        const d = new Date(str);
        d.setDate(d.getDate() - i);
        // console.log(y:" + d.getDate())
        let _year = d.getFullYear();
        let _Month =
          d.getMonth() < 9 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
        let _Day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
        let _date = d.getFullYear() + "-" + d.getMonth() + "-" + d.getDate();
        let _taDay = _date == _date2 ? true : false;
        // console.log(_date, _date2, "new Date()")
        this.daysList.push({
          day: d,
          days: _year + "-" + _Month + "-" + _Day,
          taDay: _taDay
        });
      }
      for (let i = 1; i <= 7 - this.currentWeek; i += 1) {
        const d = new Date(str);
        d.setDate(d.getDate() + i);
        let _year = d.getFullYear();
        let _Month =
          d.getMonth() < 9 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
        let _Day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
        let _date = d.getFullYear() + "-" + d.getMonth() + "-" + d.getDate();
        let _taDay = _date == _date2 ? true : false;
        // console.log(_date, _date2, "new Date()")
        this.daysList.push({
          day: d,
          days: _year + "-" + _Month + "-" + _Day,
          taDay: _taDay
        });
      }
      let beginTime =
        this.daysList[0].day.getFullYear() +
        "-" +
        (this.daysList[0].day.getMonth() + 1) +
        "-" +
        this.daysList[0].day.getDate();
      let endTime =
        this.daysList[6].day.getFullYear() +
        "-" +
        (this.daysList[6].day.getMonth() + 1) +
        "-" +
        this.daysList[6].day.getDate();
      this.TaskCenterS2(beginTime, endTime);
    },
    //  上个星期
    weekPre() {
      const d = this.daysList[0].day; // 如果当期日期是7号或者小于7号
      d.setDate(d.getDate() - 7);
      this.initData(d);
    },
    //  下个星期
    weekNext() {
      const d = this.daysList[6].day; // 如果当期日期是7号或者小于7号
      d.setDate(d.getDate() + 7);
      this.initData(d);
    },
    // 上一個月   传入当前年份和月份
    pickPre(year, month) {
      const d = new Date(this.formatDate(year, month, 1));
      d.setDate(0);
      this.initData(this.formatDate(d.getFullYear(), d.getMonth() + 1, 1));
    },
    // 下一個月   传入当前年份和月份
    pickNext(year, month) {
      const d = new Date(this.formatDate(year, month, 1));
      d.setDate(35);
      this.initData(this.formatDate(d.getFullYear(), d.getMonth() + 1, 1));
    },
    // 当前选择日期
    pick() {
      this.initData();
    },
    // 获取时间段学习任务
    TaskCenterS2(todayF, todayL) {
      let that = this;
      this.$http
        .get(
          "https://schoolapi.eiceducation.com.cn/api/TaskCenter?beginTime=" +
            todayF +
            "&endTime=" +
            todayL,
          {
            headers: {
              token: that.tokenkey
            }
          }
        )
        .then(function(result) {
          if (result.data.count > 0) {
            that.daysList.forEach(item => {
              item.alist = result.data.results.filter(items => {
                items.timestampsE = new Date(items.EndTime).getTime();
                items.timestampsB = new Date(items.BeginTime).getTime();
                items.videoTime = items.timestampsE - that.DateTime;
                return items.EndTime.slice(0, 10) == item.days;
              });
            });
            console.log(that.daysList, "that.daysList");
          }
          setTimeout(() => {
            that.daysListNew = that.daysList;
          }, 100);
        })
        .catch(function(error) {
          // console.log(error);
          that.$message.error(error);
        });
    }
  }
};
</script>

<style scoped>
.no_Data {
  padding-top: 50px;
}

.no_top {
  overflow: hidden;
  width: 100%;
  background: #ffffff;
  width: 1200px;
  background: #ffffff;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
}

.no_top .border_p {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 72px;
  border-bottom: 1px solid #ececec;
  overflow: hidden;
  padding-right: 20px;
}

.no_top .border_p span {
  display: flex;
  font-weight: 500;
  font-size: 22px;
  color: #000000;
  line-height: 30px;
}

.no_top .border_p span::before {
  content: "";
  display: block;
  width: 5px;
  height: 30px;
  background: #ff0659;
  margin-right: 25px;
}

.no_top .border_p strong {
  display: flex;
  font-weight: 400;
  font-size: 20px;
  color: #999999;
  line-height: 30px;
  cursor: pointer;
}

.no_top .border_p strong i {
  display: block;
  width: 36px;
  height: 30px;
  font-size: 18px;
  line-height: 30px;
  text-align: center;
}

.week_box {
  position: relative;
  height: 511px;
}

.week_box .week_box_top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 96px;
  padding: 0 30px;
}

.week_box .week_box_top .all_em_left {
  width: 69px;
  height: 36px;
  background: #ffffff;
  border-radius: 5px 5px 5px 5px;
  border: 1px solid #d8d8d8;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
  line-height: 36px;
  text-align: center;
  cursor: pointer;
}

.LR_btn {
  display: flex;
  justify-content: space-between;
}

.LR_btn img {
  width: 36px;
  height: 36px;
  cursor: pointer;
}

.time_box {
  width: 150px;
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  line-height: 36px;
  text-align: center;
}

.week_box .week_box_top .all_em_right {
  display: flex;
  align-items: center;
  width: 108px;
  height: 36px;
  background: #337cff;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  line-height: 36px;
  text-align: center;
  border-radius: 18px;
  padding-left: 30px;
  cursor: pointer;
}

.week_box .week_box_top .all_em_right img {
  width: 26px;
  height: 26px;
  margin-left: 20px;
}

.month_box {
  position: relative;
}

.month_box .all_em_right {
  position: absolute;
  top: 12px;
  left: 830px;
}

.month_box .all_em_right {
  display: flex;
  align-items: center;
  width: 98px;
  height: 28px;
  background: #337cff;
  font-weight: 400;
  font-size: 12px;
  color: #ffffff;
  line-height: 28px;
  text-align: center;
  border-radius: 18px;
  padding-left: 20px;
  cursor: pointer;
}

.month_box .all_em_right img {
  width: 16px;
  height: 16px;
  margin-left: 10px;
}

.date_count {
  height: 414px;
  margin: 0 30px;
  border-top: 1px #ececec solid;
}

.date_count ul {
  display: flex;
  justify-content: flex-start;
  min-height: 414px;
  border: 1px #ececec solid;
  border-top: none;
}

.date_count ul li {
  width: 20%;
  min-height: 414px;
  text-align: center;
  border-right: 1px #ececec solid;
}

.date_count ul li:hover {
  background: rgba(135, 141, 255, 0.05);
}

.date_count ul li:last-child {
  border-right: none;
}

.date_count ul li .date_count_top {
  height: 53px;
  padding-top: 5px;
  border-bottom: 1px #ececec solid;
  background: #fff;
}

.date_count ul li span {
  display: block;
  font-weight: 400;
  font-size: 12px;
  color: #999999;
  line-height: 12px;
}

.date_count ul li span strong {
  display: block;
  font-weight: 400;
  font-size: 22px;
  color: #333333;
  line-height: 26px;
  padding-bottom: 5px;
}

.date_count ul li em {
  display: block;
  width: 12px;
  height: 12px;
  background: #ffd000;
  position: absolute;
  bottom: -6px;
  left: 50%;
  margin-left: -6px;
  border-radius: 10px;
}

.date_count ul li .active strong {
  color: #ff0659;
}

.date_count ul li .date_count_bottom {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  padding-top: 10px;
}

.date_count ul li .date_count_bottom .item {
  width: 140px;
  /* height: 121px; */
  background: #ffffff;
  border-radius: 5px 5px 5px 5px;
  border: 1px solid #d8d8d8;
  margin-bottom: 10px;
}

.date_count ul li .date_count_bottom .itemTop {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 120px;
  height: 24px;
  background: rgba(255, 6, 89, 0.05);
  padding: 0 10px;
}

.date_count ul li .date_count_bottom .itemTop span {
  font-weight: 400;
  font-size: 12px;
  color: #ff0659;
  line-height: 12px;
}

.date_count ul li .date_count_bottom .itemBottom {
  padding: 10px;
}

.date_count ul li .date_count_bottom .itemBottom strong {
  display: block;
  font-weight: 400;
  font-size: 14px;
  color: #ff0659;
  line-height: 18px;
  text-align: left;
  padding-bottom: 10px;
}

.date_count ul li .date_count_bottom .itemBottom .itemButton {
  border: 1px #ececec solid;
  color: #666666;
  border-radius: 10px;
}
.date_count ul li .date_count_bottom .itemBottom .cursor {
  color: #337cff;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/page/calendar/calendar.vue